import { List } from 'immutable'

export const ROLE_ANONYMOUS_USER = 1
export const ROLE_AUTHENTICATED_USER = 2
export const ROLE_SITE_ADMIN = 4
export const ROLE_EDITOR = 3
export const ROLE_EDITOR_PLUS = 21
export const ROLE_CUSTSVC = 7
export const ROLE_AMBASSADOR_ADMIN = 43
export const ROLE_VIEW_CONTENT_ONLY = 45
export const ROLE_VIEW_MEDIA_ONLY = 46
export const ROLE_MANAGE_PLANS_MARKETING = 50
export const ROLE_MANAGE_PLANS_PRODUCT = 53
export const ROLE_MARKETING_HUB = 54

/*
  Allowed roles at login time
  used in services/auth/middleware
*/
export const LOGIN_ROLES_ALLOWED = List([
  ROLE_AUTHENTICATED_USER,
  ROLE_SITE_ADMIN,
  ROLE_EDITOR,
  ROLE_CUSTSVC,
  ROLE_AMBASSADOR_ADMIN,
  ROLE_VIEW_CONTENT_ONLY,
  ROLE_VIEW_MEDIA_ONLY,
  ROLE_MARKETING_HUB,
])

/*
  Page level authorization mapping
  - must be implemented by <Page allowedRolesKey={string}/> component to take effect
  - if you are adding a new page and want to lock it down, add an allowedRolesKey to:
    - PAGE_ROLE_MAPPING - with an array containing the roles you will allow on your page
    - <Page /> component - [allowedRolesKey] prop
*/
export const IMAGE_UPLOAD_BULK_PAGE_KEY = 'IMAGE_UPLOAD_BULK_PAGE_KEY'
export const IMAGE_UPLOAD_SIMPLE_PAGE_KEY = 'IMAGE_UPLOAD_SIMPLE_PAGE_KEY'
export const IMAGE_MANAGE_BY_CONTENT_PAGE_KEY = 'IMAGE_MANAGE_BY_CONTENT_PAGE_KEY'
export const TEXT_TRACK_UPLOAD_BULK_PAGE_KEY = 'TEXT_TRACK_UPLOAD_BULK_PAGE_KEY'
export const MERCH_CAMPAIGN_MANAGEMENT_PAGE_KEY = 'MERCH_CAMPAIGN_MANAGEMENT_PAGE_KEY'
export const USER_MANAGEMENT_PAGE_KEY = 'USER_MANAGEMENT_PAGE_KEY'
export const MENU_MANAGEMENT_PAGE_KEY = 'MENU_MANGEMENT_PAGE_KEY'
export const COMMENT_MANAGEMENT_PAGE_KEY = 'COMMENT_MANAGEMENT_PAGE_KEY'
export const REDIRECT_MANAGEMENT_PAGE_KEY = 'REDIRECT_MANAGEMENT_PAGE_KEY'
export const CONTENT_SEARCH_PAGE_KEY = 'CONTENT_SEARCH_PAGE_KEY'
export const NOTIFICATION_CENTER = 'NOTIFICATION_CENTER'
export const YOGA_HOME_PAGE = 'YOGA_HOME_PAGE'
export const USER_TAGS_PAGE_KEY = 'USER_TAGS_PAGE_KEY'
export const EVENT_MANAGEMENT_PAGE_KEY = 'EVENT_MANAGEMENT_PAGE_KEY'
export const ASSETS_MANAGEMENT_PAGE_KEY = 'ASSETS_MANAGEMENT_PAGE_KEY'
export const CONTENT_MANAGEMENT_PAGE_KEY = 'CONTENT_MANAGEMENT_PAGE_KEY'
export const CONTENT_POLICY_MANAGEMENT_PAGE_KEY = 'CONTENT_POLICY_MANAGEMENT_PAGE_KEY'
export const MEDIA_MANAGEMENT_PAGE_KEY = 'MEDIA_MANAGEMENT_PAGE_KEY'
export const FINANCE_PAGE_KEY = 'FINANCE_PAGE_KEY'
export const AMBASSADOR_PAGE_KEY = 'AMBASSADOR_PAGE_KEY'
export const USER_ABUSE_PAGE_KEY = 'USER_ABUSE_PAGE_KEY'
export const USER_MODERATION_PAGE_KEY = 'USER_MODERATION_PAGE_KEY'
export const PLANS_MANAGEMENT_KEY = 'PLANS_MANAGEMENT_KEY'
/** Admin App Marketing Performance Hub (Site Admin or dedicated marketing-hub role). */
export const MARKETING_HUB_PAGE_KEY = 'MARKETING_HUB_PAGE_KEY'
/** QA tools entry (Generate Users, etc.): same gate as user management — no billing; auth-only flows. */
export const QA_GENERATE_USERS_PAGE_KEY = 'QA_GENERATE_USERS_PAGE_KEY'

// role arrays are all OR relationship
export const PAGE_ROLE_MAPPING = {
  [USER_ABUSE_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_EDITOR, ROLE_EDITOR_PLUS],
  [IMAGE_UPLOAD_BULK_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_EDITOR, ROLE_EDITOR_PLUS],
  [IMAGE_UPLOAD_SIMPLE_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_EDITOR, ROLE_EDITOR_PLUS],
  [IMAGE_MANAGE_BY_CONTENT_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_EDITOR, ROLE_EDITOR_PLUS],
  [TEXT_TRACK_UPLOAD_BULK_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_EDITOR, ROLE_EDITOR_PLUS],
  [MERCH_CAMPAIGN_MANAGEMENT_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_EDITOR, ROLE_EDITOR_PLUS],
  [USER_MANAGEMENT_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_CUSTSVC, ROLE_AMBASSADOR_ADMIN],
  [COMMENT_MANAGEMENT_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_CUSTSVC, ROLE_EDITOR, ROLE_EDITOR_PLUS],
  [REDIRECT_MANAGEMENT_PAGE_KEY]: [
    ROLE_SITE_ADMIN,
    ROLE_EDITOR,
    ROLE_EDITOR_PLUS,
    ROLE_AMBASSADOR_ADMIN,
  ],
  [CONTENT_SEARCH_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_EDITOR, ROLE_EDITOR_PLUS],
  [NOTIFICATION_CENTER]: [ROLE_SITE_ADMIN, ROLE_EDITOR, ROLE_EDITOR_PLUS],
  [MENU_MANAGEMENT_PAGE_KEY]: [ROLE_SITE_ADMIN],
  [YOGA_HOME_PAGE]: [ROLE_SITE_ADMIN, ROLE_EDITOR, ROLE_EDITOR_PLUS],
  [EVENT_MANAGEMENT_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_EDITOR, ROLE_EDITOR_PLUS],
  [ASSETS_MANAGEMENT_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_EDITOR, ROLE_EDITOR_PLUS],
  [USER_MODERATION_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_CUSTSVC],
  [USER_TAGS_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_CUSTSVC],
  [CONTENT_MANAGEMENT_PAGE_KEY]: [
    ROLE_SITE_ADMIN,
    ROLE_EDITOR,
    ROLE_EDITOR_PLUS,
    ROLE_VIEW_CONTENT_ONLY,
    ROLE_VIEW_MEDIA_ONLY,
  ],
  [CONTENT_POLICY_MANAGEMENT_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_EDITOR_PLUS],
  [MEDIA_MANAGEMENT_PAGE_KEY]: [
    ROLE_SITE_ADMIN,
    ROLE_EDITOR,
    ROLE_EDITOR_PLUS,
    ROLE_VIEW_MEDIA_ONLY,
  ],
  [FINANCE_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_CUSTSVC],
  [AMBASSADOR_PAGE_KEY]: [ROLE_AMBASSADOR_ADMIN],
  [PLANS_MANAGEMENT_KEY]: [ROLE_SITE_ADMIN, ROLE_MANAGE_PLANS_MARKETING, ROLE_MANAGE_PLANS_PRODUCT],
  [MARKETING_HUB_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_MARKETING_HUB],
  [QA_GENERATE_USERS_PAGE_KEY]: [ROLE_SITE_ADMIN, ROLE_CUSTSVC, ROLE_AMBASSADOR_ADMIN],
}
